import * as React from "react";
import {useContext} from "react";
import '../../../assets/css/SummaryChart.css';
import {GeneralContext} from "../FSARequestLicenseContext";
import GenericChart from "./GenericChart";
import {mainMessages, overdraftKey} from "../../../assets/text/MultilingualText";
import UserContext from "../../common/UserContext";
import {useLocalization} from "@progress/kendo-react-intl";

const OverdraftChart = (props) => {
    const {
        headerInfo,
    } = useContext(GeneralContext);

    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const localization = useLocalization();

    const {
        overdraft_budget,
        overdraft_consumed,
        overdraft_cart,
        overdraft_available,
        agreement,
        start_date,
        end_date,
        currency_code,
        currency_locale,
    } = headerInfo;

    const data = [
        {
            "category": "consumed",
            "value": overdraft_consumed,
            "backgroundColor": "#F2A945",
            "fontColor": "#000000",
        },
        {
            "category": "selected",
            "value": overdraft_cart,
            "backgroundColor": "#fadeb7",
            "fontColor": "#000000",
        },
        {
            "category": "available",
            "value": overdraft_available,
            "backgroundColor": "#FFFFFF",
            "fontColor": "#000000",
        }
    ]

    return (
        <div>
            <GenericChart
                total={overdraft_budget}
                title={agreement}
                budget_name={localization.toLanguageString(overdraftKey, mainMessages[siteLanguageDefault][overdraftKey])}
                start_date={start_date}
                end_date={end_date}
                currency_code={currency_code}
                currency_locale={currency_locale}
                data={data}
            />
        </div>
    )
};

export default OverdraftChart;